export default __webpack_public_path__ + "static/media/ecommerce-tablet-main.a40e5682.webp";